import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { CompanyProvider } from "@/context/CompanyContext";
import { ConfirmProvider } from "@/components/ConfirmDialog";
import Layout from "@/components/Layout";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import HomePage from "@/pages/HomePage";
import TasksPage from "@/pages/TasksPage";
import GoalsPage from "@/pages/GoalsPage";
import MeetingsPage from "@/pages/MeetingsPage";
import TimesheetPage from "@/pages/TimesheetPage";
import IssuesPage from "@/pages/IssuesPage";
import ApprovalsPage from "@/pages/ApprovalsPage";
import InboxPage from "@/pages/InboxPage";
import SettingsPage from "@/pages/SettingsPage";
import AdminPage from "@/pages/AdminPage";
import TeamPage from "@/pages/TeamPage";
import TimesheetPrintPage from "@/pages/TimesheetPrintPage";
import MagicCallbackPage from "@/pages/MagicCallbackPage";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-slate-400 text-sm">
        Loading…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function PublicOnly({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (user) return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <CompanyProvider>
            <ConfirmProvider>
            <Routes>
              <Route path="/login" element={<PublicOnly><LoginPage /></PublicOnly>} />
              <Route path="/register" element={<RegisterPage />} />
              <Route path="/auth/magic" element={<MagicCallbackPage />} />
              <Route
                path="/timesheet/print/:periodNumber"
                element={<Protected><TimesheetPrintPage /></Protected>}
              />
              <Route path="/" element={<Protected><Layout /></Protected>}>
                <Route index element={<HomePage />} />
                <Route path="tasks" element={<TasksPage />} />
                <Route path="goals" element={<GoalsPage />} />
                <Route path="meetings" element={<MeetingsPage />} />
                <Route path="timesheet" element={<TimesheetPage />} />
                <Route path="issues" element={<IssuesPage />} />
                <Route path="approvals" element={<ApprovalsPage />} />
                <Route path="inbox" element={<InboxPage />} />
                <Route path="team" element={<TeamPage />} />
                <Route path="admin" element={<AdminPage />} />
                <Route path="settings" element={<SettingsPage />} />
              </Route>
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
            </ConfirmProvider>
          </CompanyProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
